// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__iolaH","warning":"Badge_warning__n0lmc","success":"Badge_success__EqtzM","danger":"Badge_danger__1JvEX"};